import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { HA } from "./ha";
import IG from "./locales/ig.json";
import YO from "./locales/yo.json";
import PCM from "./locales/pcm.json";
import HA2 from "./locales/ha.json";
import api from "./api";

const KEY = "dkf_lang";
const DICT = { en: {}, ha: { ...HA2, ...HA }, ig: IG, yo: YO, pcm: PCM };
export const LANGS = [["en", "English"], ["ha", "Hausa"], ["ig", "Igbo"], ["yo", "Yorùbá"], ["pcm", "Pidgin"]];

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (s) => s });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(KEY) || "en");
  const setLang = useCallback((l) => { localStorage.setItem(KEY, l); setLangState(l); }, []);
  const [overrides, setOverrides] = useState({});
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  useEffect(() => {
    if (lang === "en" || overrides[lang]) return;
    api.get(`/translations/${lang}`).then((r) => setOverrides((o) => ({ ...o, [lang]: r.data || {} }))).catch(() => setOverrides((o) => ({ ...o, [lang]: {} })));
  }, [lang, overrides]);
  const t = useCallback((s) => (lang === "en" ? s : overrides[lang]?.[s] || DICT[lang]?.[s] || s), [lang, overrides]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
export const useT = () => useContext(LangContext).t;
